import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion } from 'framer-motion';

interface ExpandableTextProps {
  text: string;
  maxLength?: number;
  className?: string;
  textClassName?: string;
  expandable?: boolean;
}

export function ExpandableText({ 
  text, 
  maxLength = 650, 
  className = "",
  textClassName = "text-muted-foreground",
  expandable = true
}: ExpandableTextProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) return null;

  if (text.length <= maxLength) {
    return <div className={`${textClassName} ${className}`}>{text}</div>;
  }

  // Corta no último espaço dentro do limite de 650 caracteres para não quebrar a palavra
  const lastSpaceIndex = text.substring(0, maxLength).lastIndexOf(" ");
  const cutIndex = lastSpaceIndex > 0 ? lastSpaceIndex : maxLength;
  const truncatedText = text.substring(0, cutIndex) + "...";

  return (
    <div className={className}>
      <motion.div 
        initial={false}
        animate={{ height: "auto" }}
        className="overflow-hidden"
      >
        <p className={`whitespace-pre-wrap ${textClassName}`}>
          {isExpanded ? text : truncatedText}
        </p>
      </motion.div>
      {expandable && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-2 flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition-colors"
        >
          {isExpanded ? 'Mostrar menos' : 'Mostrar mais'}
          <motion.div animate={{ rotate: isExpanded ? 180 : 0 }} transition={{ duration: 0.2 }}>
            <ChevronDown className="h-4 w-4" />
          </motion.div>
        </button>
      )}
    </div>
  );
}
